<div class="content-wrapper pb-3">
  <div class="page-heading d-flex align-items-center justify-content-end gap-2">
    <select
      class="form-select w-auto"
      [(ngModel)]="selectedVersion"
    >
      <option [ngValue]="null" disabled>Select Version</option>
        <option *ngFor="let v of versions" [value]="v">Version {{ v }}</option>
    </select>
    <!-- {{versions}} -->
    <button
      (click)="addSection()"
      class="btn btn-primary add-common-button"
    >
      <i class="bi bi-plus"></i>
      <span>Section</span>
    </button>
    <button (click)="confirmPDF()" class="btn btn-primary">Save PDF</button>
  </div>

  <div
    class="accordion d-flex flex-column gap-2 rules-accordian"
    id="accordionRules"
  >
    <div
      *ngFor="let section of sections; let sIndex = index"
      [ngClass]="{ collapsed: section.collapsed }"
    >
      <ng-container
        *ngTemplateOutlet="
          recursiveTemplate;
          context: {
            node: section,
            level: 0,
            indexPath: [sIndex + 1],
            section: section,
            sIndex: sIndex
          }
        "
      ></ng-container>
    </div>

    <ng-template
      #recursiveTemplate
      let-node="node"
      let-level="level"
      let-indexPath="indexPath"
      let-section="section"
      let-sIndex="sIndex"
    >
      <div class="accordion-item">
        <h2 class="accordion-header" [id]="'heading-' + indexPath.join('-')">
          <div class="d-flex justify-content-between align-items-center w-100">
            <!-- 🟢 Toggle -->
            <div
              class="accordion-button d-flex justify-content-between"
              [ngClass]="{
                'btn-expanded': !node.collapsed,
                'btn-collapsed': node.collapsed
              }"
            >
              <ng-container [ngSwitch]="level">
                <span *ngSwitchCase="0" class="flex-grow-1"
                  >Section {{ indexPath.join(".") }}</span
                >
                <span *ngSwitchCase="1" class="flex-grow-1"
                  >Rule {{ indexPath.join(".") }}</span
                >
                <span *ngSwitchDefault class="flex-grow-1"
                  >Subrule {{ indexPath.join(".") }}</span
                >
              </ng-container>
              <div class="d-flex align-items-center gap-2">
                <button
                  class="btn add-rule-btn"
                  [disabled]="node.confirm"
                  (click)="addChild(node); $event.stopPropagation()"
                  title="Add"
                >
                  <i class="bi bi-plus-circle"></i>
                  <ng-container *ngIf="level === 0; else subruleText">
                    Add Rule
                  </ng-container>
                  <ng-template #subruleText> Add Subrule </ng-template>
                </button>
                <button
                  [class.collapsed]="node.collapsed"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse-' + indexPath.join('-')"
                  aria-expanded="!node.collapsed"
                  [attr.aria-controls]="'collapse-' + indexPath.join('-')"
                  (click)="toggleCollapse(node)"
                  class="expand-collapse-btn"
                >
                  <i
                    class="bi"
                    [ngClass]="{
                      'bi-chevron-down': !node.collapsed,
                      'bi-chevron-up': node.collapsed
                    }"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </h2>

        <div
          [id]="'collapse-' + indexPath.join('-')"
          class="accordion-collapse collapse"
          [class.show]="!node.collapsed"
          [attr.aria-labelledby]="'heading-' + indexPath.join('-')"
        >
          <div class="accordion-body">
            <input
              type="text"
              class="form-control mb-3"
              title="Title"
              [(ngModel)]="node.title"
              [id]="'nodeTitle' + indexPath.join('-')"
              [readOnly]="node.confirm"
              placeholder="Enter Title"
            />

              <quill-editor
                [(ngModel)]="node.content"
                [modules]="editorConfig"
                title="Description"
                format="text"
                [id]="'nodeDesc' + indexPath.join('-')"
                placeholder="Description here..."
                [readOnly]="node.confirm"
              ></quill-editor>


            <div *ngFor="let child of node.subContents; let childIndex = index">
              <ng-container
                *ngTemplateOutlet="
                  recursiveTemplate;
                  context: {
                    node: child,
                    level: level + 1,
                    indexPath: indexPath.concat([childIndex + 1])
                  }
                "
              ></ng-container>
            </div>
          </div>

          <div
            *ngIf="
              level === 0 &&
              !section?.confirm &&
              sIndex === firstUnconfirmedSectionIndex()
            "
            class="px-3 pb-3"
          >
            <button
              (click)="confirmSection(section)"
              class="btn btn-primary btn-lg"
            >
              <i class="bi bi-check-circle"></i> Save Section
            </button>
          </div>

          <div class="px-3 pb-3" *ngIf="section?.confirm">
            <div class="alert alert-success m-0 py-2">Section confirmed.</div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
